import Link from 'next/link'
import styled from 'styled-components'

import { TypeStyle, fromMd, timingFast, withHoverSupport } from '@syconium/little-miss-figgy'

export const TabContainer = styled.div`
  display: flex;
  margin-top: ${o => o.theme.spacing(3)};
  padding: ${o => o.theme.spacing(0, 4)};
  ${fromMd} {
    padding: 0;
  }
`

export const TabText = styled(TypeStyle.HeadlineMicro).attrs({
  isUppercase: true,
  textTransform: 'uppercase',
  asTag: 'span',
})`
  font-weight: 700;
`

export const Tab = styled(Link)`
  flex-basis: 100%;
  text-align: center;
  padding: ${o => o.theme.spacing(3)} 0;
  border-style: solid;
  transition: ${timingFast} background-color ease-out;
  border-radius: 4px 4px 0px 0px;

  /* active styles are displayed when 'aria-current' is true */
  border-bottom-width: ${o => (o['aria-current'] ? '2px' : '1px')};
  border-color: ${o =>
    o['aria-current'] ? o.theme.color.deprecated.black.primary : o.theme.color.deprecated.stone};
  pointer-events: ${o => (o['aria-current'] ? 'none' : 'initial')};

  /* Change font weight of tab text when active */
  ${TabText} {
    font-weight: ${o => (o['aria-current'] ? 700 : 600)};
  }

  /* Apply hover styling to tabs on pointer devices */
  ${withHoverSupport} {
    &:hover {
      background-color: ${o => !o['aria-current'] && o.theme.color.deprecated.stoneLighter};
    }
  }
`
